import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom';
import { storage } from '../../app-firebase/firebase';
import './related-products.scss';


// function assignDownloadUrl(image, img, setImg) {
//    storage.child(image).getDownloadURL().then(url => {
//       console.log('first')
//       if(img !== url) setImg(url)
//    })
//    console.log('second')
// }

function RelatedProducts(props) {

   const list = props.list.filter(val => {

      for (let i = 0; i < val.category.length; i++) {
         if (props.category.includes(val.category[i]) && val.ipNumber !== props.ipNumber) {
            
            return val;
         }
      }
      return null
   });

   let ctr = list.length - 1;
   
   while(ctr >= 0) {
      const randIndex = Math.floor(Math.random() * ctr);
      const temp = list[ctr];
      list[ctr] = list[randIndex];
      list[randIndex] = temp;
      ctr--;
   }
   
   return list.length > 0 ? (
      <div className="pd-desc-related d-flex flex-row">
         <div className="pd-desc-related-products offset-1 col-10">
            <p>You may also like...</p>
            <div className="container">
               <div className="rp-container row row-wrap justify-content-center">
                  {list.map((val, i) => {
                     if (i < 3) {
                        return <RelatedProduct prod={val} key={val.ipNumber}/>
                     }
                     return null
                  })}
               </div>
            </div>
         </div>
      </div>
   ) : null
}




function RelatedProduct(props) {
   const [img, setImg] = useState('');

   const isMounted = useRef(false);

   useEffect(() => {
      isMounted.current = true;
      if (props.prod.image.length > 0) {
         isMounted.current && storage.ref().child(props.prod.image[0]).getDownloadURL().then(url => {
            isMounted.current && setImg(url);
         })
      } else {
         if (img !== '') {
            isMounted.current && setImg('');
         }
      }

      return () => {
         isMounted.current = false;
      }
   },[props.prod.image, img])


   

   return (
      <Link to={'/products/' + props.prod.ipNumber} className="rp-list-elem col-3">
         <div className="rp-list-elem-img">
            <img src={img} alt="Book"/>
         </div>
         <p>{props.prod.title}</p>
         <p className="rp-author">{props.prod.author}</p>
      </Link>
   );
}


export default RelatedProducts
